import React from "react"
import { Button, IconButton } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { Trans } from "@lingui/macro"
import { RowBox } from "../Boxes"
import { Icon } from "../Icon"
import { LoadingSpinner } from "../LoadingSpinner"

const useStyles = makeStyles((theme) => ({
  cancelIcon: {
    color: theme.palette.error.main
  },
  tickIcon: {
    color: theme.palette.success.main
  },
  saveButton: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.text.white,
    "&:hover": {
      backgroundColor: theme.palette.success.dark,
      boxShadow: "none"
    },
    "&:focus": {
      boxShadow: `0px 0px 0px 3px rgba(${theme.palette.success.mainRgb},0.5)`
    }
  }
}))

/**
 * Renders the article action buttons for mobile view
 */
export const renderMobileButtons = ({ classes, canEdit, isEditing, loading, onSave, onCancel }) => {
  return (
    <RowBox gap={1}>
      {canEdit && (
        <IconButton size="small" onClick={onSave} disabled={loading} className={isEditing ? classes.tickIcon : null}>
          {loading ? <LoadingSpinner size={24} delay={false} /> : <Icon name={isEditing ? "tick" : "edit"} />}
        </IconButton>
      )}
      {isEditing && (
        <IconButton size="small" disabled={loading} className={isEditing ? classes.cancelIcon : null}>
          <Icon onClick={onCancel} name="cancel" />
        </IconButton>
      )}
    </RowBox>
  )
}

/**
 * Renders the article action buttons for desktop view
 */
export const renderDesktopButtons = ({
  classes,
  canEdit,
  isEditing,
  loading,
  onSave,
  onCancel,
  buttonText,
  disabledSave = false
}) => {
  return (
    <RowBox gap={1}>
      {isEditing && (
        <Button onClick={onCancel} disabled={loading}>
          <Trans>Cancel</Trans>
        </Button>
      )}
      {canEdit && (
        <Button
          className={isEditing ? classes.saveButton : null}
          variant="contained"
          onClick={onSave}
          disabled={loading || disabledSave}
          startIcon={!isEditing ? <Icon name="edit" /> : null}
        >
          {loading ? <LoadingSpinner size={24} delay={false} /> : buttonText}
        </Button>
      )}
    </RowBox>
  )
}

export { useStyles }
